export function parsedFlightEntryCacheKey(entry) {
  if (!entry?.path || !entry?.parser) return "";
  const segment = entry.segment;
  // sourceHash and normalizedArtifactId tie DB-backed entries to the
  // specific artifact that was parsed — a re-ingest mints a new
  // normalizedArtifactId and the cache entry naturally evicts instead
  // of serving stale points from the previous artifact.
  return [
    entry.parser,
    entry.path,
    entry.auxPath ?? "",
    segment?.startIndex ?? "",
    segment?.endIndex ?? "",
    segment?.durationSeconds ?? "",
    entry.jpiFlight?.flightNumber ?? "",
    entry.jpiFlight?.startByte ?? "",
    entry.jpiFlight?.sizeBytes ?? "",
    entry.sourceHash ?? "",
    entry.database?.normalizedArtifactId ?? "",
  ].join("|");
}

export function cloneParsedFlightPoints(points) {
  return points.map((point) => ({
    ...point,
    ...(Array.isArray(point.sourceSampleIndices) ? { sourceSampleIndices: [...point.sourceSampleIndices] } : {}),
  }));
}

export function cloneParserWarnings(warnings = []) {
  return warnings.map((warning) => ({ ...warning }));
}

export function cloneEngineLayout(engineLayout) {
  if (!engineLayout || typeof engineLayout !== "object") return null;
  return {
    ...engineLayout,
    engineIds: Array.isArray(engineLayout.engineIds) ? [...engineLayout.engineIds] : engineLayout.engineIds,
    cylindersPerEngine: Array.isArray(engineLayout.cylindersPerEngine) ? [...engineLayout.cylindersPerEngine] : engineLayout.cylindersPerEngine,
    egtGroups: Array.isArray(engineLayout.egtGroups) ? engineLayout.egtGroups.map((group) => Array.isArray(group) ? [...group] : group) : engineLayout.egtGroups,
    chtGroups: Array.isArray(engineLayout.chtGroups) ? engineLayout.chtGroups.map((group) => Array.isArray(group) ? [...group] : group) : engineLayout.chtGroups,
  };
}

export function cloneParsedFlightEnvelope(envelope) {
  return {
    ...envelope,
    engineLayout: cloneEngineLayout(envelope.engineLayout),
    ...(envelope.cgrTwinAlignment ? { cgrTwinAlignment: structuredClone(envelope.cgrTwinAlignment) } : {}),
    parserWarnings: cloneParserWarnings(envelope.parserWarnings),
    ...(envelope.sourceData ? { sourceData: structuredClone(envelope.sourceData) } : {}),
    points: cloneParsedFlightPoints(envelope.points),
  };
}

export function parserMetadataFromEnvelope(envelope) {
  return {
    schemaVersion: envelope.schemaVersion,
    parserId: envelope.parserId,
    parserVersion: envelope.parserVersion,
    parserConfidence: envelope.parserConfidence,
    parserWarnings: cloneParserWarnings(envelope.parserWarnings),
    engineLayout: cloneEngineLayout(envelope.engineLayout),
    engineFamily: envelope.engineFamily,
    engineMake: envelope.engineMake,
    engineModel: envelope.engineModel,
    engineCooling: envelope.engineCooling,
    engineControl: envelope.engineControl,
    cgrTwinAlignment: envelope.cgrTwinAlignment ? structuredClone(envelope.cgrTwinAlignment) : null,
    comboAlignment: envelope.comboAlignment ?? null,
    auxSeriesKeys: Array.isArray(envelope.auxSeriesKeys) ? [...envelope.auxSeriesKeys] : null,
  };
}

export function cloneParserMetadata(metadata) {
  if (!metadata) return null;
  return {
    ...metadata,
    parserWarnings: cloneParserWarnings(metadata.parserWarnings),
    engineLayout: cloneEngineLayout(metadata.engineLayout),
    ...(metadata.cgrTwinAlignment ? { cgrTwinAlignment: structuredClone(metadata.cgrTwinAlignment) } : {}),
    ...(Array.isArray(metadata.auxSeriesKeys) ? { auxSeriesKeys: [...metadata.auxSeriesKeys] } : {}),
  };
}
